export const config = {
    "dev": {
        BACKEND_URL: "https://api.dev.kwikmemories.com",
        CDN_URL: "https://d2k6rj3fg12oy7.cloudfront.net",
        RAZORPAY_KEY: "rzp_test_gQAw4fxmsaihmF",
        LANDING_PAGE: "https://kwikmemories-landing-ten.vercel.app",
        CASHFREE_MODE: "sandbox"    
    },
    "local": {
        BACKEND_URL: "http://127.0.0.1:8000",
        CDN_URL: "https://d2k6rj3fg12oy7.cloudfront.net",
        RAZORPAY_KEY: "rzp_test_gQAw4fxmsaihmF",    
        LANDING_PAGE: "https://kwikmemories-landing-ten.vercel.app",
        CASHFREE_MODE: "sandbox"
    },
    "prod": {
        BACKEND_URL: "https://api.kwikmedia.in",
        CDN_URL: "https://dxabh2dfp7tng.cloudfront.net",    
        RAZORPAY_KEY: "rzp_live_RFvHPdrBVeP7Zz",
        LANDING_PAGE: "https://kwikmemories-landing-ten.vercel.app",
        CASHFREE_MODE: "production"
    }
}
type EnvKey = keyof typeof config;  
export const env: EnvKey = (
    process.env.REACT_APP_NODE_ENV === "prod"
        ? "prod"
        : process.env.REACT_APP_NODE_ENV === "dev"
            ? "dev"
            : "local"
) as EnvKey;

export const IMAGE_CDN = config[env].CDN_URL

export const LANDING_PAGE = config[env].LANDING_PAGE

export const CASHFREE_MODE = config[env].CASHFREE_MODE